import type { getProjectDevices } from '../services/deviceService'

export type ChatWidgetDeviceContextItem = {
  name: string
  shortUUID?: string
  assetId?: string | null
  deviceCode?: string | null
  assetName?: string | null
  type?: string | null
  label?: string
}

export function mapProjectDevicesToChatContext(
  devices: Awaited<ReturnType<typeof getProjectDevices>>
): ChatWidgetDeviceContextItem[] {
  return devices.map((device) => {
    const assetName = device.asset?.name?.trim() ?? null
    const deviceName = device.name?.trim() ?? ''
    const deviceTypeLabel = device.type ? `tyyppi ${String(device.type).toUpperCase()}` : null
    const deviceIdentityLabel = device.shortUUID
      ? `MAC ${device.shortUUID}`
      : device.deviceCode
        ? `koodi ${device.deviceCode}`
        : null
    const normalizedNameParts = new Set<string>(
      [assetName, device.shortUUID, device.deviceCode]
        .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
        .map((value) => value.trim().toLowerCase())
    )
    const deviceNameLabel =
      deviceName && !normalizedNameParts.has(deviceName.toLowerCase())
        ? `laite ${deviceName}`
        : null

    return {
      name: device.name,
      shortUUID: device.shortUUID,
      assetId: device.asset?.id ?? device.assetId ?? null,
      deviceCode: device.deviceCode,
      assetName: device.asset?.name ?? null,
      type: device.type ?? null,
      label: [assetName, deviceIdentityLabel, deviceTypeLabel, deviceNameLabel]
        .filter(Boolean)
        .join(' • ')
    }
  })
}
